import { useQuery } from "@tanstack/react-query"
import React, { createContext, useContext } from "react"

import { useAppContext } from "@contexts/app_context"
import { getMobileAppVersionConfigs } from "@domain/mobile_app_version"
import { type MobileAppVersionConfig } from "@models/mobile_app_version"

type MobileAppVersionPageContextType = {
  translate: (key: string) => string
  configs: MobileAppVersionConfig[]
  isLoading: boolean
}

const MobileAppVersionPageContext =
  createContext<MobileAppVersionPageContextType>({
    translate: (key: string) => key,
    configs: [],
    isLoading: false
  })

export function MobileAppVersionPageContextProvider(props: {
  children: JSX.Element | JSX.Element[]
}) {
  const { translate } = useAppContext()

  const { data, isLoading } = useQuery({
    queryKey: ["mobile-app-version-configs"],
    queryFn: async () => (await getMobileAppVersionConfigs()).data ?? []
  })

  return (
    <MobileAppVersionPageContext.Provider
      value={{ translate, configs: data ?? [], isLoading }}
    >
      {props.children}
    </MobileAppVersionPageContext.Provider>
  )
}

export function useMobileAppVersionPageContext() {
  return useContext(MobileAppVersionPageContext)
}
